var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import axios from 'axios';
import { injectable } from 'inversify';
import { EventResponseStatus, PostableType } from '@/dto';
import { validateOrReject } from 'class-validator';
var POST_RESOURCES = (_a = {},
    _a[PostableType.SURVEY] = 'surveys',
    _a[PostableType.NEWS] = 'news',
    _a[PostableType.NEIGHBOURHOOD_AID] = 'neighbourhood-aids',
    _a[PostableType.MARKETPLACE] = 'marketplaces',
    _a[PostableType.DOCUMENT] = 'documents',
    _a[PostableType.EVENT] = 'events',
    _a);
var PostsService = /** @class */ (function () {
    function PostsService() {
        this.baseEndpoint = '/api/v1';
        this.likesEndpoint = '/api/v1/likes/toggle';
        this.surveyParticipationEndpoint = '/api/v1/survey-participation';
        this.surveyCloseEndpoint = '/api/v1/surveys';
        this.neighbourhoodInterestEndpoint = '/api/v1/neighbourhood-aid-interests';
        this.repeatingEventsEndpoint = this.baseEndpoint + "/repeating-events";
        this.marketplacePostInterestEndpoint = '/api/v1/marketplace-interests';
        this.postsEndpoint = '/api/v1/posts';
        this.blockAuthorsEndpoint = '/api/v1/block-authors';
        this.blockedAuthorsEndpoint = '/api/v1/blocked-authors';
        this.eventApplicationsEndpoint = '/api/v1/event-applications';
        this.eventInvitationsEndpoint = '/api/v1/event-invitations';
        this.eventResponsesEndpoint = '/api/v1/event-responses';
    }
    PostsService.prototype.create = function (post) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(post)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, axios.post(this.baseEndpoint + "/" + POST_RESOURCES[post.postableType], post.toRestModel())];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    PostsService.prototype.createRecurrentEvent = function (post) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(post)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, axios.post(this.repeatingEventsEndpoint, post.toRestModel())];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    PostsService.prototype.update = function (post) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(post)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, axios.patch(this.baseEndpoint + "/" + POST_RESOURCES[post.postableType] + "/" + post.uuid, post.toRestModel())];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.delete = function (uuid, postableType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.delete(this.baseEndpoint + "/" + POST_RESOURCES[postableType] + "/" + uuid)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PostsService.prototype.toggleLike = function (like) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validateOrReject(like)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, axios.post(this.likesEndpoint, like.toModel())];
                }
            });
        });
    };
    PostsService.prototype.participateToSurvey = function (survey_id, survey_choice_ids) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post(this.surveyParticipationEndpoint, { survey_id: survey_id, survey_choice_ids: survey_choice_ids })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.closeSurvey = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.surveyCloseEndpoint + "/" + uuid + "/resolve")];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.toggleInterestToNeighbourhoodAid = function (neighbourhoodUuid, attach) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.neighbourhoodInterestEndpoint + "/" + neighbourhoodUuid + "/" + (attach ? 'attach' : 'detach'))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.eventParticipation = function (eventUuid, response_status) {
        if (response_status === void 0) { response_status = EventResponseStatus.ACCEPT; }
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post(this.baseEndpoint + "/event-responses/" + eventUuid + "/respond", { response_status: response_status })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.toggleInterestToMarketplacePost = function (marketplace, attach) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.marketplacePostInterestEndpoint + "/" + marketplace + "/" + (attach ? 'attach' : 'detach'))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.toggleResolvePost = function (post, resolve) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.postsEndpoint + "/" + post + "/" + (resolve ? 'resolve' : 'unresolve'))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.hidePostsFormAuthor = function (authorId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post("" + this.blockAuthorsEndpoint, {
                            author_id: authorId,
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.removeIgnoredAuthor = function (authorId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.delete(this.blockedAuthorsEndpoint + "/" + authorId)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.applyToEvent = function (event_id, body) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post(this.eventApplicationsEndpoint, { event_id: event_id, body: body })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.respondToEvent = function (uuid, response_status) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post(this.eventResponsesEndpoint + "/" + uuid + "/respond", { response_status: response_status })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    PostsService.prototype.inviteToEvent = function (event_id, email, body) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.post(this.eventInvitationsEndpoint, {
                            event_id: event_id,
                            users: Array.isArray(email) ? email : [email],
                            body: body,
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.data];
                }
            });
        });
    };
    PostsService.prototype.cancelEventInvitation = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.delete(this.eventInvitationsEndpoint + "/" + uuid)];
            });
        });
    };
    /**
     * @param uuid UUID from the post
     */
    PostsService.prototype.eventApplicationApprove = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.eventApplicationsEndpoint + "/" + uuid + "/approve")];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @param uuid UUID from the post
     */
    PostsService.prototype.eventApplicationDecline = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.patch(this.eventApplicationsEndpoint + "/" + uuid + "/decline")];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * @param uuid UUID from the event invitations
     */
    PostsService.prototype.resendEventInvitation = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, axios.post(this.eventInvitationsEndpoint + "/" + uuid + "/resend")];
            });
        });
    };
    PostsService = __decorate([
        injectable()
    ], PostsService);
    return PostsService;
}());
export { PostsService };
